import { render } from "./showProjects.vue?vue&type=template&id=8855f464&scoped=true"
import script from "./showProjects.vue?vue&type=script&lang=js"
export * from "./showProjects.vue?vue&type=script&lang=js"

import "./showProjects.vue?vue&type=style&index=0&id=8855f464&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8855f464"]])

export default __exports__